export default __webpack_public_path__ + "static/media/restart-button-wood.e3c03e31.png";